// ** Modules
import React from 'react';

type HeaderOverride = {
	appBarVariant: 'light' | 'dark';
	showMenu: boolean;
} | null;

const HeaderOverrideContext = React.createContext<{
	override: HeaderOverride;
	setOverride: (o: HeaderOverride) => void;
}>({
	override: null,
	setOverride: () => console.warn('HeaderOverrideProvider not found: setOverride called without a provider.')
});

export const HeaderOverrideProvider = ({ children }: { children: React.ReactNode }) => {
	const [overrideState, setOverrideState] = React.useState<HeaderOverride>(null);
	const [isHeroPresent, setIsHeroPresent] = React.useState(false);

	const setOverride = React.useCallback((o: HeaderOverride) => {
		setOverrideState(o);
		setIsHeroPresent(o !== null);
	}, []);

	// The fallback ONLY applies if isHeroPresent is false AND overrideState is null
	const effectiveOverride: HeaderOverride =
		isHeroPresent && overrideState ? overrideState : { appBarVariant: 'light', showMenu: true };

	return (
		<HeaderOverrideContext.Provider value={{ override: effectiveOverride, setOverride }}>
			{children}
		</HeaderOverrideContext.Provider>
	);
};

export const useHeaderOverride = () => React.useContext(HeaderOverrideContext);
